import { setDecompositionTreeAttributeFilter as setDecompositionTreeAttributeFilterDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type Props = ApiMethodBase & {
    attributeFilter?: String,
}

export const applyAttributeFilter = ({
    attributeFilter,
    eventEmitter,
}: Props) => {
    setDecompositionTreeAttributeFilterDiagram(attributeFilter);
    eventEmitter.emit(Event.applyFilter);
};
